import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { CommonModalDataModel } from '../common-modals.model';
import { CommonModalsActionsEnum } from '../common-modals-actions.enum';

@Component({
  selector: 'rnpl-confirm-modal',
  templateUrl: './confirm-modal.component.html'
})
export class ConfirmModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CommonModalDataModel
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  ngOnInit(): void {
    const overlay = document.querySelector<HTMLElement>('.cdk-overlay-container');
    overlay.style.zIndex = '1200';

    this.dialogRef.afterClosed().subscribe(() => {
      overlay.style.zIndex = '1000';
    });
  }

  public confirmAction(): void {
    this.dialogRef.close(CommonModalsActionsEnum.CONFIRM);
  }

  public rejectAction(): void {
    this.dialogRef.close(CommonModalsActionsEnum.REJECT);
  }

}

